import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GrupoUsuario, RecursoGrupo } from 'src/class/grupo-usuario';
import { Recurso } from 'src/class/recurso';
import { newUsuario } from 'src/class/usuario';
import { CepService } from 'src/services/cep.service';
import { GrupoUsuarioService } from 'src/services/component/grupo-usuario.service';
import { RecursoService } from 'src/services/component/recurso.service';
import { ContadorIndexService } from 'src/services/contador-index.service';
import { DataService } from 'src/services/data.service';
import { SiglaService } from 'src/services/siglaService.service';
import { ToastService } from 'src/services/toast.service';
import { TranslateWordService } from 'src/services/translate-word.service';
import { UsuariosService } from 'src/services/usuarios.services';
import { ValidatorService } from 'src/services/validator.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

declare var bootstrap: any;

@Component({
  selector: 'app-criar-grupo',
  templateUrl: './criar-grupo-usuario.component.html',
  styleUrls: ['./criar-grupo-usuario.component.css']
})
export class CriarGrupoUsuarioComponent implements OnInit,OnDestroy {
  private destroy$: Subject<void> = new Subject<void>()

  @ViewChild('alertGrupoUsuarioModal', { static: false }) alertGrupoUsuarioModal!: ElementRef;
  @ViewChild('resources', {static: true}) resources!: MatSelectionList;

  usr_id: string = "";
  usr_tipo: string = "";
  usr_token: string = "";

  usr_obj: any = [];

  usr_new = new newUsuario;

  grupo: GrupoUsuario = new GrupoUsuario();
  grupos: GrupoUsuario[] = [];
  empresaSigla: any | undefined;

  recursos: any[] = [];

  constructor(
    private router: Router,
    private usuarios: UsuariosService,
    private toast: ToastService,
    private validatorService: ValidatorService,
    private cepService: CepService,
    private translateWord: TranslateWordService,
    private contadorIndexService: ContadorIndexService,
    private grupoUsuarioService: GrupoUsuarioService,
    private route: ActivatedRoute,
    private siglaService: SiglaService,
    private recursoService: RecursoService
  ){
    // Alimenta o serviço com a empresaSigla
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.route.params.subscribe(params => {
          this.empresaSigla = params['empresaSigla'];
          this.siglaService.setEmpresaSigla(this.empresaSigla?.toString());
          this.recursoService.getRecurso(this.empresaSigla);
        });
      }
    });
  }

  async ngOnInit() {

    try{
      const usr = JSON.parse(localStorage.getItem('user')!);
      // this.usr_id = usr.Id;
      // this.usr_tipo = usr.GrupoUsuario;
      // this.usr_token = usr.Token;
      this.usr_id = "1";
      this.usr_tipo = "M";
      this.usr_token = "usr.Token";
      if(this.usr_tipo != "M" && this.usr_tipo != "A"){
        this.router.navigate(['/home']);
      }
    }catch{
      this.router.navigate(['/home']);
    }

    this.recursoService.getAllRecurso()
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (recursos: Recurso[]) => {
        // console.log(recursos)
        // Faça algo com as notificações atualizadas

        recursos.sort((a, b) => {
          const nomeA = a.nome.valor.toUpperCase();
          const nomeB = b.nome.valor.toUpperCase();
          if (nomeA < nomeB) {
            return -1;
          }
          if (nomeA > nomeB) {
            return 1;
          }
          return 0;
        });

        this.recursos = recursos;

        // setTimeout(() => {
        //   const rec = this.recursos.slice(0,5)
        //   this.selectAllResources(rec);
        // }, 1000);

      },
      error => {
        // console.error('Erro ao listar os Tipos:', error);
        this.router.navigate(['/home']);
      }
    );

  }

  selectAllResources(recursos: any[]): void {
    const time = setInterval(()=>{
      if(this.resources && this.resources.options){
        clearInterval(time);

        recursos.forEach((rec: any) => {
            const resourceId = rec.id; // Obtém o ID do recurso
            const option = this.resources.options.toArray().find((opt: any) => opt.value.id === resourceId);
            if(option){
              option.selected = true; // Seleciona a opção com o ID correspondente
            }
        });

      }
    })
  }

  routerLink(rota: string, id: any = null){
    if(id != null){
      this.router.navigate([`${this.empresaSigla}/${rota}`, id]);
    }else{
      this.router.navigate([`${this.empresaSigla}/${rota}`]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSelectedResources() {
    for (let index = 0; index < this.resources.selectedOptions.selected.length; index++) {
      const element = this.resources.selectedOptions.selected[index];
      // console.log(element.value)
    }
    return this.resources.selectedOptions.selected.map(option => option.value);
  }

  async criarGrupoUsuario(){
    this.grupo.nome.status = this.validatorService.criarValidacao(this.grupo.nome.valor, this.grupo.nome.validacoesCustomizadas);
    this.grupo.descricao.status = this.validatorService.criarValidacao(this.grupo.descricao.valor, this.grupo.descricao.validacoesCustomizadas);

    const resources_qtd = this.getSelectedResources();

    // if(resources_qtd.length == 0){
    //   this.showError("Por favor, selecione pelo menos 1 recurso para o grupo")
    // }else
    if(this.grupo.nome.status.invalid ||
      this.grupo.descricao.status.invalid
    ){
      this.abrirModal(this.alertGrupoUsuarioModal.nativeElement);
    }else{

      this.grupo.id = await this.contadorIndexService.contadorIndex();
      let new_grupo  = new GrupoUsuario();
      new_grupo = this.grupo;

      new_grupo.criado = new Date();
      new_grupo.atualizado = new Date();

      let recursos: RecursoGrupo[] = [];

      // console.log(this.resources.selectedOptions)
      for (let index = 0; index < this.resources.selectedOptions.selected.length; index++) {
        const element = this.resources.selectedOptions.selected[index];
        // console.log(element.value)
        const rec = new RecursoGrupo();

        rec.idRecurso = element.value.id
        rec.NomeRecurso = element.value.nome.valor

        recursos.push(rec)
      }

      new_grupo.recursos = recursos;

      const grupo = JSON.stringify(new_grupo);
      const res = await this.grupoUsuarioService.criarGrupoUsuario(JSON.parse(grupo), this.empresaSigla)
      // console.log(res)

      // this.showSuccess("GrupoUsuario criado com sucesso");
      this.grupo = new GrupoUsuario();
      this.router.navigate([`${this.empresaSigla}/grupos-usuarios`]);
    }
  }

  abrirModal(event: any) {
    // Ativar o modal usando a biblioteca do Bootstrap
    const modal = new bootstrap.Modal(event);
    modal.show();
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }
}
